import ErrorMessage from '@minecraft.error-message';
import { ThreeDSecureAction } from '@recurly/react-recurly';
import React, { Component } from 'react';
import { TokenPayload } from '@recurly/recurly-js';
import styled from 'styled-components';
import { captureExceptionEvent } from '../../Sentry';
import { WalletLoader } from '../Checkout/WalletLoader';
import { UseThreeDSecureFlow } from './useThreeDSecureFlow';

type ThreeDSecureFormProps = {
  threeDActionToken: UseThreeDSecureFlow['threeDActionContext']['token'];
  onToken: (token: TokenPayload) => void;
  onError: UseThreeDSecureFlow['onThreeDActionError'];
  loading: boolean;
};

export const StyledThreeDWrapper = styled.div`
  position: absolute;
  height: 400px;
  margin: auto;

  & > div {
    height: 100%;
  }
`;

// This component needs to be a class to catch any render exceptions that may happen
// in the ThreeDSecureAction component which could suffer from cross domain issues and other unknowns
export class ThreeDSecureForm extends Component<ThreeDSecureFormProps, { renderedError?: boolean }> {
  static getDerivedStateFromError(error) {
    console.error('Error rendering ThreeDSecureForm', error);
    captureExceptionEvent(error);

    return { renderedError: true };
  }

  constructor(props: ThreeDSecureFormProps) {
    super(props);
    this.state = { renderedError: false };
  }

  componentDidCatch(error) {
    captureExceptionEvent(error);
    console.error('Error rendering ThreeDSecureForm', error);
  }

  render() {
    const { renderedError } = this.state;
    const { threeDActionToken, onToken, onError, loading } = this.props;

    if ((!threeDActionToken && !renderedError) || loading) return <WalletLoader />;

    return (
      <>
        {renderedError ? (
          <ErrorMessage />
        ) : (
          <StyledThreeDWrapper>
            <ThreeDSecureAction actionTokenId={threeDActionToken} onToken={onToken} onError={onError} />
          </StyledThreeDWrapper>
        )}
      </>
    );
  }
}
